<script>
    import {incrementItemInCart, decrementItemInCart} from "./cart-store.js";
    import {t} from "../core/i18n/language-store.js";

    export let item;
    export let publishConfig;
    export let tenantKey;
</script>

<style>
    .item-container {
        display: flex;
        gap: 1rem;
    }
    .info-block {
        flex: 1 1;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .title {
        font-size: .825rem;
        text-transform: uppercase;
        font-family: var(--font-1);

        overflow-wrap: break-word;
        word-break: break-word;
    }
    .price {
        font-family: var(--font-2);
        font-size: 1.2rem;
    }
    .count {
        display: flex;
        align-items: center;
        gap: .25rem;
    }
    .count span {
        font-size: 1.25rem;
        font-family: var(--font-2);
        min-width: 1.25rem;
        text-align: center;
    }
    button {
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        background: transparent;
        padding: 0;

        font-size: 1.5rem;
        height: 1.5rem;
        color: var(--main-font-color);
    }
</style>


<div class="item-container">

    <div class="info-block">
        <div class="title">
            { item.name || $t('cart.unnamed') }{#if (item.weight !== undefined)}, { item.weight }{/if}
        </div>
        {#if (item.modsDescription?.length > 0)}
            <div>
            <span class="fs-85">{ item.modsDescription }</span>
            </div>
        {/if}
        <div class="price">
            {#if (item.price !== null && item.price !== undefined)}
                <span class="price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                    <span>{ item.price }</span>
                    <span>{ publishConfig?.currency || '' }</span>
                </span>
            {/if}
        </div>
    </div>

    <div class="count">
        <button class="pointer" on:click={() => decrementItemInCart(item, item.price, item.priceIndex, item.mods)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CircleMinus"><path d="M16 12H8"/><circle cx="12" cy="12" r="10"/></svg>
        </button>
        <span>{ item.count }</span>
        <button class="pointer" on:click={() => incrementItemInCart(item, item.price, item.priceIndex, item.mods)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
        </button>
    </div>

</div>
